import {
  PositioningContextInput,
  PositioningContextTypeInput
} from "@pathwright/graphql-client/src/generated"

export const COVER_PAGE_CONTRIBUTOR_POSITION_ITEM_KEY = "author"
export const COVER_PAGE_CATEGORY_POSITION_ITEM_KEY = "category"

export const getCoverPagePositioningContextKey = (
  resourceId: number | string
) => `resource:${resourceId}`

export const getContributorPositioningContext = (
  resourceId: number | string
): PositioningContextInput => ({
  contextType: PositioningContextTypeInput.ResourceAuthors,
  contextKey: getCoverPagePositioningContextKey(resourceId)
})

export const getCategoryPositioningContext = (
  resourceId: number | string
): PositioningContextInput => ({
  contextType: PositioningContextTypeInput.ResourceCategories,
  contextKey: getCoverPagePositioningContextKey(resourceId)
})
